/* eslint-disable import/no-cycle */
import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersistence from 'vuex-persist';

import { app } from './modules/app.module';
import { auth } from './modules/auth.module';
import { alert } from './modules/alert.module';
import { confirm } from './modules/confirm.module';
import { modal } from './modules/modal.module';
import { user } from './modules/user.module';
import { system } from './modules/system.module';

Vue.use(Vuex);

const vuexLocal = new VuexPersistence({
  storage: window.localStorage,
  // Non persistere i flag transitori (es. loggingIn): altrimenti, se la pagina
  // viene ricaricata durante un login in corso, al reload il pulsante resterebbe
  // bloccato in loading a tempo indeterminato.
  reducer: state => ({
    ...state,
    auth: { ...state.auth, loggingIn: false },
    // Lo stato di irraggiungibilita' del backend e' transitorio: se venisse
    // persistito, un reload mostrerebbe la manutenzione anche a servizio tornato su.
    system: { unavailable: false, reason: null, checking: false },
  }),
});

export const store = new Vuex.Store({
  modules: {
    app,
    auth,
    alert,
    confirm,
    modal,
    user,
    system,
  },
  plugins: [vuexLocal.plugin],
});

// Sana lo stato reidratato: se un login era rimasto "in corso" quando la pagina
// e' stata chiusa/ricaricata, il pulsante di login resterebbe bloccato in loading.
store.commit('auth/resetLoggingIn');
